import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/api/auth/login.service';
import { environment } from 'src/app/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  email: string = '';
  password: string = '';
  otpCode: string = ''; // Nueva variable para el código
  emailCompany: string = ''; // Nueva variable para el código
  tempUserId: any = null; // Para guardar el ID que responda Laravel
  step: 'login' | 'otp' = 'login'; // Control de vista
  nameApp: string = 'Nombre App';

  constructor(private authService: LoginService, public router: Router) {
    this.nameApp = environment.name_app;
  }

  // login() {
  //   const user = { email: this.email, password: this.password };
  //   this.showloaderLogin();
  //   this.authService.login(user).subscribe(
  //     data => {
  //       this.authService.setUserData(data.user);
  //       this.authService.setToken(data.user.remember_token);
  //       this.hideloaderLogin();
  //       this.router.navigateByUrl('admin/sucursales');
  //       this.getPermissionsUser();
  //     },
  //     error => {
  //       console.log(error);
  //       this.hideloaderLogin();
  //       Swal.fire({
  //         icon: 'warning',
  //         title: 'Datos Incorrectos',
  //         text: error.error.error
  //       });
  //     }
  //   );
  // }

  login() {
    const user = { email: this.email, password: this.password };
    this.showloaderLogin();
    this.authService.login(user).subscribe(
      data => {
        this.hideloaderLogin();
        if (data.status === 'otp_required') {
          this.tempUserId = data.user_id;
          this.emailCompany = data.email_company;
          this.step = 'otp'; // Cambiamos a la vista de OTP
        } else {
          this.authService.setUserData(data.user);
          this.authService.setToken(data.user.remember_token);
          this.hideloaderLogin();
          this.router.navigateByUrl('admin/sucursales');
          this.getPermissionsUser();
        }
      },
      error => {
        this.hideloaderLogin();
        Swal.fire({
          icon: 'warning',
          title: 'Datos Incorrectos',
          text: error.error.error
        });
      }
    );
  }

  // Nuevo método para verificar el código
  verifyOtp() {
    if (!this.otpCode) return;

    this.showloaderLogin();
    const payload = {
      user_id: this.tempUserId,
      otp_code: this.otpCode
    };

    this.authService.verifyOtp(payload).subscribe(
      data => {
        // Aquí recibimos el usuario y token final (Tu lógica original)
        this.authService.setUserData(data.user);
        this.authService.setToken(data.user.remember_token);
        this.hideloaderLogin();
        this.router.navigateByUrl('admin/sucursales');
        this.getPermissionsUser();
      },
      error => {
        this.hideloaderLogin();
        Swal.fire({
          icon: 'error',
          title: 'Código Incorrecto',
          text: error.error.error
        });
      }
    );
  }

  maskEmail(email: string): string {
    if (!email || !email.includes('@')) return email;
    
    const [name, domain] = email.split('@');
    
    // Si el nombre es muy corto (ej: a@gm.com), mostramos solo la primera letra
    if (name.length <= 2) {
        return name.substring(0, 1) + '***@' + domain;
    }
    
    // Para nombres normales: primera letra + asteriscos + última letra + dominio
    return name.substring(0, 1) + '*****' + name.substring(name.length - 1) + '@' + domain;
}

  getPermissionsUser() {
    this.authService.permissions().subscribe(
      data => {
        this.authService.setUserPermissions(data.permissions);
      },
      error => {
        console.log(error);
      }
    );
  }

  showloaderLogin() {
    (<HTMLInputElement>(
      document.getElementById('box-loading-login')
    )).style.display = 'flex';
  }

  hideloaderLogin() {
    (<HTMLInputElement>(
      document.getElementById('box-loading-login')
    )).style.display = 'none';
  }
}
